export default "./src/client/components/auth/login/open-web/spid-button/img/spid-ico-circle-bb.svg?9abc7ee7e0b3c438121d0453dd646e82";